import { isChainHeadSelector } from 'selectors';
import { initGrid } from 'utils/grid/grid';
import { checkAccess } from 'app/actions/app.actions';
import { clearFilters, fetchRetailerReports, downloadRetailerReport } from 'retailer-reports/actions/retailer-reports.actions';
import { loadReportExtensions, loadReportNames } from 'app/actions/dictionaries.actions';
import { fetchReportCategoriesDictionary } from 'app/actions/dictionaries/report-categories-dictionary.actions';
import template from './retailer-reports-tab-content.html';

const mapStateToThis = ({ ui, session, retailerReports, dictionaries, dictionary, config }) => {
  const { pagination } = ui;
  const isChainHead = isChainHeadSelector({ session });
  const { sortColumnKey, directionKey } = config;
  const { locale, isAdmin } = session;
  const { reportCategories } = dictionary;
  const { items, isLoading } = retailerReports;
  const { reportNames, reportExtensions } = dictionaries;

  return {
    pagination,
    items,
    isLoading,
    reportNames,
    reportCategories,
    reportExtensions,
    isChainHead,
    locale,
    isAdmin,
    sortColumnKey,
    directionKey,
  };
};

const mapDispatchToThis = {
  fetchRetailerReports,
  loadReportNames,
  fetchReportCategoriesDictionary,
  loadReportExtensions,
  downloadRetailerReport,
  checkAccess,
  clearFilters,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications')
class RetailerReportsTabContentController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.showSubordinates = this.isChainHead;
    this.showSubscriptionButton = this.checkAccess('reportSubscriptions.view');
    this.headers = this.getHeaders();
    this.errors = {};
    this.defaultParams = {
      [this.sortColumnKey]: 'created',
      [this.directionKey]: false,
    };
    this.gridModel = initGrid(this.fetchRetailerReports, this.defaultParams);
    await Promise.all([this.loadReportNames(), this.fetchReportCategoriesDictionary(), this.loadReportExtensions()]);
    if (!this.isAdmin && !this.showSubordinates) {
      this.search();
    }
  }

  $onDestroy() {
    this.clearFilters();
    this.unsubscribe();
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Report Name'),
        field: 'fileType.fileTypeTranslations.fileDisplayNm',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Date'),
        field: 'created',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Category'),
        field: 'fileType.fileTypeTranslations.fileCategoryCd',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Description'),
        sortable: false,
        textAlignment: 'text-left',
      },
    ];
  }

  async search() {
    if (this.isAdmin && !this.gridModel.pagingModel.filters.retailerNumber) {
      this.Notifications.alertError(this.gettextCatalog.getString('Please provide Retailer No.'));
      return;
    }
    if (this.errors.date) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Invalid date'));
      return;
    }
    await this.gridModel.applyFilters();
  }

  clearFilter() {
    this.errors = {};
    this.gridModel = initGrid(this.fetchRetailerReports, this.defaultParams);
    this.clearFilters();
    if (!this.isAdmin) {
      this.search();
    }
  }

  downloadReport(file) {
    return this.downloadRetailerReport({
      ...file,
      filters: this.gridModel.pagingModel.filters,
    });
  }

  onRetailerClick({ id, displayNumber, retailerType }) {
    this.showSubordinates = false;
    this.gridModel.pagingModel.filters.retailerId = id;
    this.gridModel.pagingModel.filters.retailerNumber = displayNumber;
    this.retailerType = retailerType;
    return this.search();
  }

  backToSubordinatesList() {
    this.showSubordinates = true;
    this.gridModel.pagingModel.filters.retailerId = null;
    this.gridModel.pagingModel.filters.retailerNumber = null;
  }

  openMySubscriptions() {
    this.$state.go('reportSubscriptions-view', {
      retailerId: this.gridModel.pagingModel.filters.retailerId,
      retailerNumber: this.gridModel.pagingModel.filters.retailerNumber,
      retailerType: this.retailerType,
    });
  }
}

export default class RetailerReportsTabContentComponent {
  constructor() {
    this.template = template;
    this.controller = RetailerReportsTabContentController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-tab-content/retailer-reports-tab-content-component.js